import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  GetStartedInput,
  AboutBanner,
  FootprintDeprecated
} from '../../components'
import container from '../../helpers/container'

import Styles from './CarbonFootprint.css'

@CSSModules(Styles)
export default class CarbonFootprint extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Carbon footprint'
    const description = 'Get your money out of fossil fuels. Use Fossil Free Funds to see the carbon footprint of your investments.'
    const url = config.domain + config.routes.carbonfootprint

    const bannerImage = 'footprint'
    const bannerHeadline = 'Carbon footprint'
    const bannerSubtitle = 'Measuring financed emissions'

    //
    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='image-banner-container'>
          <div styleName='image-banner-container-inner'>
            <div styleName={'image-banner-'+bannerImage}>
              <div styleName='image-banner-headline'>{bannerHeadline}</div>
              <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
            </div>
          </div>
        </div>

        <div styleName='page'>
          <ContainerDivs>
            <FootprintDeprecated />
            <div styleName='title'>
              Measure the carbon emissions financed by your mutual fund
              investments
            </div>
            <div styleName='x-carbon-footprint-info-photo'>
              <div styleName='x-carbon-footprint-info'>
                <p>
                  Fossil fuel companies and those emitting large quantities
                  of CO2 have come under increasing levels of scrutiny for
                  their large and direct responsibility for climate change.
                  For investors, such companies are increasingly seen as
                  potentially risky investments, as they are likely to face
                  increasing costs, shrinking profits, and a need to
                  fundamentally redesign their business models.
                </p>
                <p>
                  "Carbon footprinting" a mutual fund means accounting for
                  the quantification and management of GHGs. It is the first
                  step towards understanding an investor’s impact on climate
                  change. A carbon footprint is calculated by measuring
                  and/or estimating the quantities and assessing the sources
                  of various GHG emissions that can be directly or indirectly
                  attributed to the activities of the underlying holdings.
                </p>
                <p>
                  To independently analyze and calculate carbon footprints
                  for the mutual funds, we used the <strong>Carbon Footprint
                    Analysis Tool</strong> of yourSRI.com.
                </p>
              </div>
              <div
                styleName='x-carbon-footprint-photo'
                title='Carbon footprinting'
              />
            </div>
            <div styleName='image-banner-subtitle'>
              <em>Brought to you by As You Sow - Carbon footprint profile
              delivered by yourSRI.com</em>
            </div>
          </ContainerDivs>
          <GetStartedInput/>

          <div styleName='content-container'>
            <div styleName='content-container-inner'>
              <div styleName='section-title'>
                The concept of financed emissions
              </div>
              <p>The basis for a carbon footprint is the annual GHG emissions of each company within the respective fund. All direct operations, as well as energy and heat consumption, are measured in metric tonnes of carbon dioxide equivalent (tCO2e). The footprint is based on the full holdings of each fund per the most recently available Morningstar data, and the corresponding greenhouse gas emission data.</p>
              <p>To allocate company GHG emissions to a fund, the value of shares held by the fund is set in relation to the company’s market capitalization. This ratio is multiplied with the emissions of the company, resulting in the emissions "owned" by the investor. By aggregating the information on a fund level, an investment carbon footprint for the fund is established and expressed in absolute and relative terms.</p>
              <p>The described approach allows for the direct association and quantification of the emissions per investment and per fund. It also enables investors to compare the climate-intensity of one fund with another. For the ranking of the assessed funds, a relative metric has been applied to avoid any bias resulting from the size of the funds.</p>
              <p>yourSRI.com’s company GHG data covers the entire investable universe. This is achieved through collecting data from different data sources, data validation and estimation of missing data points with 800 proprietary models. Thorough stress tests of the data are conducted to ensure accuracy.</p>
              <p>
                <Link
                  to={config.links.yoursrimethodology}
                  xstrong={true}
                  title='yourSRI.com Methodology'>
                  Read the yourSRI.com Carbon Footprint Analysis Tool methodology document<LinkIcon />
                </Link>
              </p>
              <div styleName='section-title'>
                Relative carbon footprint
              </div>
              <p>The relative carbon footprint expresses the greenhouse gas footprint of an investment sum. It is a normalized measure of a portfolio’s contribution to climate change that enables comparison with a benchmark, between portfolios, and between individual investments. The relative carbon footprint is measured in Total Carbon Emissions expressed as per currency invested.</p>
              <div styleName='section-title'>
                Scope 1, 2, and 3 emissions
              </div>
              <p>Greenhouse gas (GHG) emissions are classified as per the Greenhouse Gas Protocol and are grouped in categories called Scope 1, Scope 2 and Scope 3.</p>
              <p><strong>Scope 1 GHG emissions</strong> are those directly occurring “from sources that are owned or controlled by the institution, including: on‐campus stationary combustion of fossil fuels; mobile combustion of fossil fuels by institution owned/controlled vehicles; and &slquo;fugitive emissions’. ”</p>
              <p><strong>Scope 2 emissions</strong> are “indirect emissions generated in the production of electricity consumed by the institution.”</p>
              <p><strong>Scope 3 emissions</strong> are all the other indirect emissions that are “a consequence of the activities of the institution, but occur from sources not owned or controlled by the institution such as commuting; embodied emissions from extraction, production, and transportation of purchased goods; outsourced activities; contractor‐owned vehicles; and line loss from electricity transmission and distribution”. In the data, Scope 3 emissions are conceptually divided into (a) upstream emissions, i.e. emissions stemming from a company’s supply chain and (b) downstream emissions, i.e. emissions from product “use phases” during their life cycle.</p>
              <div styleName='section-title'>
                yourSRI.com
              </div>
              <p>With its online platform yourSRI.com, CSSP helps asset managers and asset owners worldwide to adequately manage risks related to ESG and Carbon issues. Investors can use the online tool to score mainstream mutual funds, portfolios, and mandates to efficiently benchmark and to compare investments with peers.</p>
              <p>
                <Link
                  to={config.links.yoursri}
                  xstrong={true}
                  title='yourSRI.com'>
                  Visit yourSRI.com online to learn more<LinkIcon />
                </Link>
              </p>

              <AboutBanner />

            </div>
          </div>
        </div>
      </div>
    )
  }
}
